import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { EnvService } from '@src/app/modules/env';
import { SessionService } from '@src/app/modules/auth';
import { DocumentPageType } from '@src/app/modules/app-config';
import { CAPTCHA_POLICY_LINK } from '@src/app/modules/captcha';

import { EnterTypeEnum } from './types';
import { BASE_PATH_DOCUMENTS } from './constant';

@Component({
  selector: 'app-login-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicyComponent {
  private readonly env = inject(EnvService);
  private readonly session = inject(SessionService);

  /** Тип входа */
  @Input() pageName?: DocumentPageType;

  /** Тип входа */
  @Input() enterType?: EnterTypeEnum;

  /** Закрыть страницу */
  @Output() close: EventEmitter<void> = new EventEmitter();

  readonly EnterType = EnterTypeEnum;
  readonly basePathDocuments = BASE_PATH_DOCUMENTS;
  readonly captchaPolicyLink = CAPTCHA_POLICY_LINK;

  get appConfig() {
    return this.session.appConfig;
  }

  get isCordova() {
    return this.env.isCordova;
  }

  closePage() {
    this.close.emit();
  }
}
